import firebase from "firebase/compat/app"

import { E2E_PROJECT_ID, PREPROD_PROJECT_ID, PROD_PROJECT_ID } from "./projectIds"

// Détection d'environnement via Firebase projectId (même méthode que le backend)
const getEnvironmentConfig = () => ({
  baseUrl: "https://auth.integ01.dev-franceconnect.fr/api/v2",
  clientId: "d2fdb79d9829d65d43e371d1235c34fbb49bd3198388fe280354772233d637a1",
  redirectUrl: `https://europe-west1-${PREPROD_PROJECT_ID}.cloudfunctions.net/franceConnectLogin`,
})

const envConfig = getEnvironmentConfig()

const fcPlusConfig = {
  issuer: envConfig.baseUrl,
  clientId: envConfig.clientId,
  redirectUrl: envConfig.redirectUrl,
  scopes: ["openid", "given_name", "family_name", "birthdate", "gender"],
  additionalParameters: {
    acr_values: "eidas2",
  },
  usePKCE: false,
  serviceConfiguration: {
    authorizationEndpoint: `${envConfig.baseUrl}/authorize`,
    tokenEndpoint: `${envConfig.baseUrl}/token`,
    endSessionEndpoint: `${envConfig.baseUrl}/session/end`,
  },
}

export const generateLoginUrl = (nonce: string, state: string) => {
  const { clientId, redirectUrl, scopes, additionalParameters } = fcPlusConfig
  const params = new URLSearchParams({
    response_type: "code",
    client_id: clientId,
    redirect_uri: redirectUrl,
    scope: scopes.join(" "),
    ...additionalParameters,
    nonce,
    state,
  })
  return `${envConfig.baseUrl}/authorize?${params.toString()}`
}

export const generateLogoutUrl = (state: string, idToken: string) => {
  const projectId = (firebase.app().options as any).projectId

  let logoutCallbackUrl: string

  switch (projectId) {
    case PROD_PROJECT_ID:
      logoutCallbackUrl = "https://europe-west1-doctup-a2cca.cloudfunctions.net/franceConnectLogout"
      break
    case PREPROD_PROJECT_ID:
      logoutCallbackUrl =
        "https://europe-west1-doctup-pre-prod.cloudfunctions.net/franceConnectLogout"
      break
    case E2E_PROJECT_ID:
      logoutCallbackUrl = "http://localhost:5001/doctup-e2e-test/europe-west1/franceConnectLogout"
      break
    default:
      throw new Error(`Logout callback URL non définie pour projectId: ${projectId}`)
  }

  const params = new URLSearchParams({
    post_logout_redirect_uri: logoutCallbackUrl,
    state,
  })
  if (idToken) {
    params.append("id_token_hint", idToken)
  }

  return `${envConfig.baseUrl}/session/end?${params.toString()}`
}

export const getCallbackUrlScheme = (): string => {
  const projectId = (firebase.app().options as any).projectId

  switch (projectId) {
    case PROD_PROJECT_ID:
      return "com.siruplab.doctup://callback"

    case PREPROD_PROJECT_ID:
      return "com.siruplab.doctup.preprod://callback"

    case E2E_PROJECT_ID:
      return "com.siruplab.doctup.e2e://callback"

    default:
      throw new Error(`URL scheme non défini pour projectId: ${projectId}`)
  }
}

/**
 * Construit un callback FranceConnect pour les tests E2E
 * Génère un code mock et construit l'URL de callback correspondante
 * @returns L'URL de callback avec le code généré
 */
export const buildE2ECallback = (): string => {
  const code = `e2e-mock-code-${Date.now()}`
  const callbackUrl = `${getCallbackUrlScheme()}?code=${code}`
  return callbackUrl
}

export default fcPlusConfig
